import React from 'react';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

import { useAppDispatch } from '@project/reducers/store';
import { LoginProps, ResetPasswordProps } from '@project/types';
import { decodedToken, userAuthService } from '@project/services';
import { FormContainer, ResetPasswordForm } from '@project/components';
import { setUserRole } from '@project/reducers/userRole-reducer/userRole.actions';
import { useRoleRedirect } from '@project/hooks';

const ResetPasswordScreen: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const redirectByRole = useRoleRedirect();

  const onSubmit = async (formData: ResetPasswordProps) => {
    await userAuthService.resetPassword(formData);

    const loginData: LoginProps = {
      username: formData.email,
      password: formData.password,
      remember: false,
    };

    return userAuthService.login(loginData);
  };

  const onSuccess = async () => {
    toast.success('Successfully Reset Password');
    const role = decodedToken.getRole();
    await dispatch(setUserRole(role));
    redirectByRole(role);
  };

  const initialValues: ResetPasswordProps = {
    password: '',
    confirmPassword: '',
    token: new URLSearchParams(location.search).get('token') || '',
    email: new URLSearchParams(location.search).get('email') || '',
  };

  return (
    <FormContainer>
      <ResetPasswordForm
        initialValues={initialValues}
        submitForm={onSubmit}
        onSuccess={onSuccess}
        onFailure={() => null}
      />
    </FormContainer>
  );
};

export default ResetPasswordScreen;
